<template>
  <TransitionRoot
    appear
    :show="isOpen"
    as="template"
  >
    <Dialog
      as="div"
      class="relative z-30 rounded-lg"
      @close="closeModal"
    >
      <TransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-black/75" />
      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto">
        <div class="flex min-h-full lg:items-center items-start justify-center p-4 text-center">
          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <DialogPanel
              class="dialog-wrapper"
            >
              <button
                class="dialog__close-button"
                type="button"
                @click="closeModal"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  class="size-8"
                  fill="currentColor"
                >
                  <path d="M15.5355 7.05024L16.9497 8.46446L8.46447 16.9497L7.05025 15.5355L15.5355 7.05024Z" />
                  <path d="M16.9497 15.5355L15.5355 16.9497L7.05025 8.46446L8.46447 7.05024L16.9497 15.5355Z" />
                </svg>
              </button>

              <slot />
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup lang="ts">
import { defineModel } from 'vue';
import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogPanel,
} from '@headlessui/vue';

interface Props {
  open: boolean
}

defineProps<Props>();

const isOpen = defineModel<Props['open']>('open', { default: false });
const emit = defineEmits(['close']);

function closeModal () {
  isOpen.value = false;
  emit('close');
}
</script>

<style scoped>
.dialog-wrapper {
  @apply w-full xl:max-w-7xl transform overflow-hidden bg-brand-white text-left align-middle shadow-xl transition-all relative min-h-[10vh] rounded-lg p-4;
}
.dialog__close-button {
  @apply rounded-full size-8 top-5 right-5 p-1 border border-brand-black absolute inline-flex ;
  @apply items-center hover:bg-brand-black justify-center bg-brand-white hover:text-brand-white transition-colors duration-300 z-50;
}
</style>
